__turbopack_context__.v({
  "component": "style-module-scss-module__pcRNuG__component",
  "description": "style-module-scss-module__pcRNuG__description",
  "heading": "style-module-scss-module__pcRNuG__heading",
  "preferenceContent": "style-module-scss-module__pcRNuG__preferenceContent",
  "preferenceIcon": "style-module-scss-module__pcRNuG__preferenceIcon",
  "preferenceItem": "style-module-scss-module__pcRNuG__preferenceItem",
  "preferenceLabel": "style-module-scss-module__pcRNuG__preferenceLabel",
  "preferenceValue": "style-module-scss-module__pcRNuG__preferenceValue",
  "preferencesGrid": "style-module-scss-module__pcRNuG__preferencesGrid",
});
